import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { StatTile } from '../components/ui/StatTile';
import { Section, EmptyNote, UserLink, TableWrap, Th, Td } from '../components/ui/bits';
import { useSel } from '../lib/queries';
import { supabase } from '../lib/supabase';
import { fmtDate } from '../lib/format';

export const LearnPage: React.FC = () => {
  const { data: stats } = useSel<any[]>(['learn-stats'], async () => {
    const [progress, certs, gates, gatesPassed, tech] = await Promise.all([
      supabase.from('learn_progress').select('*', { count: 'exact', head: true }),
      supabase.from('learn_certificates').select('*', { count: 'exact', head: true }),
      supabase.from('learn_gate_attempts').select('*', { count: 'exact', head: true }),
      supabase.from('learn_gate_attempts').select('*', { count: 'exact', head: true }).eq('passed', true),
      supabase.from('technical_progress').select('user_id').limit(2000),
    ]);
    return {
      data: [{
        enrolments: progress.count, certs: certs.count, gates: gates.count, gatesPassed: gatesPassed.count,
        techUsers: new Set((tech.data ?? []).map(t => t.user_id)).size,
      }],
      error: progress.error,
    };
  });
  const s = (stats as any)?.[0];

  const { data: recent } = useSel<any[]>(['learn-recent'], () =>
    supabase.from('learn_progress').select('user_id, programme, current_module, current_phase, last_activity_at, completed_at').order('last_activity_at', { ascending: false }).limit(20));

  return (
    <div>
      <PageHeader title="Learn and technicals" subtitle="Course enrolment, gate pass rates and technical prep. Read-only." />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4">
        <StatTile label="Course enrolments" value={s?.enrolments ?? 0} accent="indigo" />
        <StatTile label="Certificates issued" value={s?.certs ?? 0} accent="emerald" />
        <StatTile label="Gate attempts" value={s?.gates ?? 0} accent="stone" />
        <StatTile label="Gate pass rate" value={s?.gates ? `${Math.round((s.gatesPassed / s.gates) * 100)}%` : 'none'} accent="stone" />
        <StatTile label="Technical prep users" value={s?.techUsers ?? 0} accent="violet" />
      </div>
      <Section title="Recent learners">
        {(recent ?? []).length === 0 ? <EmptyNote>Nobody enrolled yet</EmptyNote> : (
          <TableWrap>
            <thead><tr><Th>User</Th><Th>Programme</Th><Th>Module</Th><Th>Phase</Th><Th>Last active</Th><Th>Completed</Th></tr></thead>
            <tbody>
              {(recent ?? []).map((r, i) => (
                <tr key={i}>
                  <Td><UserLink id={r.user_id} /></Td>
                  <Td>{r.programme}</Td>
                  <Td className="tabular-nums">{r.current_module}</Td>
                  <Td>{r.current_phase}</Td>
                  <Td>{fmtDate(r.last_activity_at)}</Td>
                  <Td>{r.completed_at ? fmtDate(r.completed_at) : ''}</Td>
                </tr>
              ))}
            </tbody>
          </TableWrap>
        )}
      </Section>
    </div>
  );
};
